import React, { useCallback, useEffect, useState } from "react";
import { Col, Input, Modal, Row, Spin } from "antd";
import CustomButton from "components/Common/buttons/CustomButton";
import { makeStyles } from "@material-ui/core/styles";
import ConfirmationModal from "components/Common/modals/ConfirmationModal";
import NGISelect from "components/Common/inputs/NGISelect";
import { Option } from "antd/es/mentions";
import { SEARCH_BY } from "pages/customer-management/customerDetails/constants";
import TitleWithDivider from "components/Common/components/TitleWithDivider";
import { defaultNgiErrorMethod, successMessage } from "components/Common/responses/message";
import starIcon from "assets/images/svg/Star.svg";
import { TYPES_MAP } from "pages/price-management/Bundles/variables";
import time from "assets/images/svg/Time Span.svg";
import cylinder from "assets/images/svg/Gas Bottle.svg";
import price from "assets/images/svg/Price Tag.svg";
import duration from "assets/images/svg/Timesheet.svg";
import timesheet from "assets/images/svg/Date To.svg";
import classnames from "classnames";
import { createBundleAssignment, getBundles } from "utils/api";

const useStyles = makeStyles({
  modal: {
    "& .ant-modal-content .ant-modal-body": {
      padding: "24px 0px !important",
    },
  },
  successModal: {
    width: "500px!important",
  },
  titleWithDescription: {
    display: "flex",
    flexDirection: "column",
    textAlign: "left",
    fontWeight: 600,

    "&>span": {
      fontSize: 13,
      fontWeight: 300,
    },
  },
  container: {
    borderBottom: "1px solid rgba(0, 0, 0, 0.05)",
    borderLeft: "none",
    borderRight: "none",
    marginBottom: 30,
    paddingBottom: 30,
    padding: "0 50px",
  },
  tabs: {
    "&.ant-tabs > .ant-tabs-nav, .ant-tabs > div > .ant-tabs-nav": {
      padding: "0px!important",
      margin: 0,
    },
  },
  actions: {
    display: "flex",
    justifyContent: "space-between",
    padding: "0px 50px",
  },
  stepsContainer: {
    padding: "20px 50px",
    backgroundColor: "#0000000D",
    border: "1px solid #0000000D",
  },
  withMargin: {
    marginLeft: 10,
  },
  typeTitle: {
    textTransform: "capitalize",
  },

  // review
  select: {
    width: "100%",

    "& .ant-select-selector": {
      border: "none!important",
    },
  },
  searchRow: {
    border: "1px solid #00000026",
    borderRadius: 4,
    "&>:first-child": {
      borderRight: "1px solid #00000026",
    },
  },
  groupTitle: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: 16,
    fontWeight: 600,
    padding: "10px 0",
  },
  subTitle: {
    fontSize: 13,
    fontWeight: 400,
    color: "#8C8C8C",
  },
  addedListContainer: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    maxHeight: 600,
    overflow: "auto",
    padding: "5px 2px",
  },
  itemWrapper: {
    width: "100%",
    backgroundColor: "#00000008",
    borderRadius: 5,
    padding: 12,
    marginTop: 6,
    position: "relative",
  },
  listItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  removeIcon: {
    cursor: "pointer",
    height: 20,
  },
  typeName: {
    width: "80%",
    display: "flex",
    alignItems: "center",
    "&>img": {
      marginRight: 5,
      width: 20,
    },
  },
  qty: {
    width: "20%",
  },
  error: {
    fontSize: 9,
    color: "#FF0000",
    position: "absolute",
    bottom: 3,
    left: 37,
  },

  inputSearch: {
    height: "100%",
    border: "none",
    borderRadius: 4,
  },

  saveContainer: {
    display: "flex",
    alignItems: "center",

    "&> div:first-child": {
      fontWeight: 300,
      fontSize: 13,
    },
  },
  dividerStyles: {
    color: "#00000080",
    fontSize: 11,
    fontWeight: 500,
  },
  noDataContainer: {
    padding: "50px 0",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",

    "&> div:first-child": {
      fontWeight: 600,
      fontSize: 16,
    },
    "&> div:last-child": {
      fontWeight: 300,
      fontSize: 13,
    },
  },

  bundleList: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
    marginTop: 15,
  },
  bundleListInUse: {
    gap: 0,
  },
  dataItem: {
    display: "flex",
    flexDirection: "row",
    border: "1px solid #0000001A",
    borderRadius: 5,
    padding: "10px 0",
    cursor: "pointer",
  },
  filled: {
    backgroundColor: "#0000000A",
    height: 45,
  },
  infoContainer: {
    display: "flex",
    padding: 20,
    flex: 2,
  },
  name: {
    fontWeight: 600,
    flex: 1,

    "&>img": {
      marginLeft: 5,
      marginTop: -2,
    },
  },
  dataContainer: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    borderTop: "none",
    borderBottom: "none",
    fontWeight: 500,
  },
  assignedToName: {
    fontWeight: 600,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    textDecoration: "underline",

    "&:hover": {
      cursor: "pointer",
      opacity: 0.6,
    },
  },
  category: {
    display: "flex",
    alignItems: "center",
    fontWeight: 500,
    flex: 1,
  },
  actionsContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderLeft: "1px solid #0000001A",
  },
  assignBtn: {
    fontWeight: 500,
    border: "1px dashed #0000004D",
    backgroundColor: "#f0f0f0",
    padding: "5px 20px",
    borderRadius: 3,
    textAlign: "center",
    width: "100%",

    "&:hover": {
      cursor: "pointer",
      opacity: 0.6,
    },
  },
  leftContainer: {
    display: "flex",
    flex: 2,
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 10px",
  },
  section: {
    display: "flex",
    alignItems: "center",
    flexGrow: 0.3,
    justifyContent: "flex-end",

    "& img": {
      width: 30,
      marginRight: -5,
    },
  },
  title: {
    fontSize: 13,
    fontWeight: 300,

    "&>img": {
      height: 16,
    },
  },
  data: {
    fontSize: 13,
    fontWeight: 600,
    marginLeft: 5,
  },
  bundleName: {
    display: "flex",
    fontWeight: 600,
    width: "30%",

    "&>img": {
      width: 12,
      marginLeft: 5,
      marginTop: -2,
    },
  },
  sectionTitle: {
    color: "#777777",
    fontWeight: 400,
    fontSize: 11,
    marginTop: 10,

    "&>img": {
      marginRight: 4,
      marginTop: -2,
    },
  },
  selected: {
    backgroundColor: "#0085FF",
    color: "white",
  },
});

const AssignBundleModal = ({ onClose, update, customerId }) => {
  const classes = useStyles();
  const [isLoading, setLoader] = useState(false);
  const [isSaveOpen, setIsSaveOpen] = useState(false);
  const [list, setList] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [searchType, setSearchType] = useState(null);
  const [searchValue, setSearchValue] = useState(null);
  const [debouncedValue, setDebouncedValue] = useState("");

  const openSaveOpenModal = useCallback(() => setIsSaveOpen(true), []);
  const closeSaveOpenModal = useCallback(() => setIsSaveOpen(false), []);

  const onAssign = useCallback(() => {
    closeSaveOpenModal();
    setLoader(true);
    const activeItem = list.find(item => item.id === selectedItem);

    createBundleAssignment({
      bundleId: activeItem.id,
      type: "Customer",
      customerId,
    })
      .then(() => {
        setLoader(false);
        successMessage("Bundle Assignment was created successfully");
        onClose();
        update();
      })
      .catch(e => {
        defaultNgiErrorMethod(e);
        setLoader(false);
      });
  }, [selectedItem, customerId, list]);

  useEffect(() => {
    search();
  }, []);

  const search = useCallback(() => {
    setSelectedItem(null);

    setList([]);
    setLoader(true);

    getBundles(
      searchType && debouncedValue
        ? { [searchType === "Name" ? "name" : "id"]: debouncedValue }
        : {
            status: "Active",
          }
    )
      .then(res => {
        const {
          result: { items },
        } = res.data;

        setList(items || []);
        setLoader(false);
      })
      .catch(err => {
        setLoader(false);
        defaultNgiErrorMethod(err);
      });
  }, [searchType, debouncedValue]);

  const onBundleClick = useCallback(e => {
    const { id } = e.currentTarget.dataset;
    setSelectedItem(prevState => (prevState === id ? null : id));
  }, []);

  const onTypeChange = useCallback(value => {
    if (!value) {
      search();
      setSearchValue(null);
    }
    setSearchType(value);
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(searchValue);
    }, 1000);

    return () => clearTimeout(handler);
  }, [searchValue]);

  useEffect(() => {
    if (debouncedValue) {
      search();
    }
  }, [debouncedValue]);

  const onSearchValueChange = useCallback(e => setSearchValue(e.target.value), []);

  return (
    <Modal
      title={
        <div className={classes.titleWithDescription}>
          Assign Bundle
          <span>Click on a bundle to mark it for assignment. You can select multiple bundles</span>
        </div>
      }
      open
      onCancel={onClose}
      closable={false}
      className={classes.modal}
      footer={[]}
    >
      <Spin spinning={isLoading}>
        <div className={classes.container}>
          <Row className={classes.searchRow}>
            <Col span={6}>
              <NGISelect className={classes.select} placeholder="Please Select" onChange={onTypeChange} allowClear>
                {SEARCH_BY.map(item => (
                  <Option key={item} value={item}>
                    {item}
                  </Option>
                ))}
              </NGISelect>
            </Col>
            <Col span={18}>
              <Input
                className={classes.inputSearch}
                value={searchValue}
                onChange={onSearchValueChange}
                placeholder="Enter value"
              />
            </Col>
          </Row>
          <TitleWithDivider title="Results Found" className={classes.dividerStyles} />
          <div className={classes.listContainer}>
            {list.length ? (
              <div className={classes.bundleList}>
                {list?.map(item => (
                  <div
                    data-id={item.id}
                    onClick={onBundleClick}
                    key={item.id}
                    className={classnames(classes.dataItem, selectedItem === item.id && classes.selected)}
                  >
                    <div className={classes.leftContainer}>
                      <div className={classes.bundleName}>
                        {searchType === "Name" ? item.displayName : item.id}
                        {item.isPrimary && <img src={starIcon} alt="is Primary" />}
                      </div>

                      <div className={classes.section}>
                        <div className={classes.title}>Type</div>
                        <div className={classes.data} title={TYPES_MAP[item.type]}>
                          {TYPES_MAP[item.type]}
                        </div>
                      </div>
                      <div className={classes.section}>
                        <div className={classes.title}>
                          <img src={item.type === "TB" ? time : cylinder} alt="cylinder" />
                        </div>
                        <div className={classes.data} title={item.lpgOrTime}>
                          {item.lpgOrTime}
                        </div>
                      </div>
                      <div className={classes.section}>
                        <div className={classes.title}>
                          <img src={price} alt="price" />
                        </div>
                        <div className={classes.data} title={item.price}>
                          {item.price}
                        </div>
                      </div>
                      <div className={classes.section}>
                        <div className={classes.title}>
                          <img src={duration} alt="duration" />
                        </div>
                        <div className={classes.data} title={item.duration}>
                          {item.validityPeriod}
                        </div>
                      </div>
                      <div className={classes.section}>
                        <div className={classes.title}>
                          <img src={timesheet} alt="timesheet" />
                        </div>
                        <div
                          className={classes.data}
                          title={`${item.activationDate} / ${item?.deactivationDate ? item.deactivationDate : "-"}`}
                        >
                          {`${item.activationDate} / ${item?.deactivationDate ? item.deactivationDate : "-"}`}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className={classes.noDataContainer}>
                <div>No Results Found</div>
                <div>Please update your search criteria to find results</div>
              </div>
            )}
          </div>
        </div>
        <div className={classes.actions}>
          <CustomButton onClick={onClose} type="primary" size="small" color="outlined" text="Cancel" />

          <div className={classes.saveContainer}>
            {!selectedItem && <div>No bundles selected</div>}
            <CustomButton
              className={classes.withMargin}
              size="small"
              text="ASSIGN BUNDLES"
              type="primary"
              disabled={!selectedItem}
              onClick={openSaveOpenModal}
            />
          </div>
        </div>
      </Spin>

      {isSaveOpen && (
        <ConfirmationModal
          description="Are you sure you want to assign bundle?"
          onCancel={closeSaveOpenModal}
          onConfirm={onAssign}
        />
      )}
    </Modal>
  );
};

export default AssignBundleModal;
